<head>
  <meta charset="UTF-8">
</head>
<h1>{{ 'turbo.Bookings.RequestPaymentDialog.lblHeadline2' | translate:'Request payment' }}</h1>
<mat-dialog-content style="min-width: 600px;">
  <t4-container>
    <ng-container *ngIf="backoffice">
      <mat-form-field style="margin-right:5px;" appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select [(ngModel)]="_selectedSmsType" (ngModelChange)="onSmsTypeChange($event)">
          <mat-option *ngFor="let type of smsTypeOptions" [value]="type.fullKey">
            {{ type.displayName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-container>
      <div class="row" style="padding-top: 15px; margin-left: 5px;">
        <div class="col-3" style="white-space:nowrap">
          {{ 'turbo.Bookings.RequestPaymentDialog.lblReceiver' | translate : 'Receiver'}}:
        </div>
        <div class="col" style="white-space:nowrap">
          {{ email }}
        </div>
      </div>
      <div class="row" style="padding-bottom:15px; margin-left:5px;">
        <div class="col-3" style="white-space:nowrap">
          {{ 'turbo.Bookings.RequestPaymentDialog.lblAmount' | translate : 'Amount'}}:
        </div>
        <div class="col" style="white-space:nowrap">
          {{ amount | currency }}
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="white-space:nowrap">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'turbo.Bookings.RequestPaymentDialog.txtSms' | translate : 'Notification sms'}}</mat-label>
            <textarea cdkTextareaAutosize #txtInput type="text" matInput [(ngModel)]="description" cdkAutosizeMinRows="5"></textarea>
            <mat-error>{{ 'turbo.Bookings.RefundDialog.errRefundDescriptiontInvalid' | translate : 'Invalid description'}}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-xs-12" style="text-align: center">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="validate()">{{ 'turbo.Bookings.RequestPaymentDialog.cmdConfirm' | translate : 'Send'}}</button>
  </div>
</mat-dialog-actions>
